<template>
    <div class="dropdown w-100">
        <button ref="dropdownToggle" class="btn btn-secondary btn-block text-left bg-white text-dark dropdown-toggle"
                type="button"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span v-if="range.start === null || range.end === null" class="text-muted">
                {{ __('actions.select_thing', {thing: __('general.time_frame')}) }}
            </span>
            <span v-else>
                <Badge>{{ $localDateTime(range.start, dateFormat) }}</Badge>
                <i class="fas fa-arrow-circle-right mx-1 text-muted" style="font-size: .86rem;" />
                <Badge>{{ $localDateTime(range.end, dateFormat) }}</Badge>
            </span>
        </button>
        <div class="dropdown-menu">
            <form class="p-5 d-flex flex-column gap-2">
                <div>
                    <label class="font-weight-bold">
                        {{ __('general.start_date') }}
                    </label>
                    <input type="datetime-local" class="form-control form-control-solid" v-model="range.start">
                </div>
                <div>
                    <label class="font-weight-bold">
                        {{ __('general.end_date') }}
                    </label>
                    <input type="datetime-local" class="form-control form-control-solid" v-model="range.end">
                </div>
                <div class="btn-group w-100 mt-3">
                    <button type="button" class="btn btn-primary text-nowrap" @click="submit">
                        <i class="fas fa-filter"/>
                        {{ __('actions.filter.date') }}
                    </button>
                    <button type="button" class="btn btn-secondary text-nowrap" @click="clear">
                        <i class="fas fa-eraser"/>
<!--                        {{ __('actions.clear_selection') }}-->
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Badge from "@components/Badge.vue";

export default {
    components: {Badge},
    props: {
        value: {
            type: Object,
            default() {
                return {
                    start: null,
                    end: null
                };
            }
        }
    },

    data() {
        return {
            range: this.value,
            dateFormat: {
                year: '2-digit',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
            }
        }
    },

    methods: {
        clear() {
            this.range = {
                start: null,
                end: null
            }
            this.submit();
            this.$refs.dropdownToggle.click();
        },

        submit() {
            this.$emit('input', {
                start: this.range.start?.replace('T', ' '),
                end: this.range.end?.replace('T', ' '),
            })
        }
    }
}
</script>
